import { render, staticRenderFns } from "./dataPermissionGrant.vue?vue&type=template&id=394b3be0&scoped=true&"
import script from "./dataPermissionGrant.vue?vue&type=script&lang=ts&"
export * from "./dataPermissionGrant.vue?vue&type=script&lang=ts&"
import style0 from "./dataPermissionGrant.vue?vue&type=style&index=0&id=394b3be0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394b3be0",
  null
  
)

export default component.exports